import { render, staticRenderFns } from "./RealtimeActivity.vue?vue&type=template&id=be44b45e&scoped=true"
import script from "./RealtimeActivity.vue?vue&type=script&lang=js"
export * from "./RealtimeActivity.vue?vue&type=script&lang=js"
import style0 from "./RealtimeActivity.vue?vue&type=style&index=0&id=be44b45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be44b45e",
  null
  
)

export default component.exports